export interface SearchConfig {
  product?: SearchEndpointConfig;
  recommend?: SearchEndpointConfig;
  inspiration?: SearchEndpointConfig;
}

interface SearchEndpointConfig {
  siteId?: string;
  siteUrl?: string;
  context?: string;
}

export const searchConfig =
  typeof SEARCH_CONFIG !== 'undefined' ? SEARCH_CONFIG : {};
